import { ContentType } from '@src/__generated__/types';

const FORM_FIELDS = [
    'text',
    'html',
    'image',
    'file',
    'currency',
    'dateRange',
    'measure',
    'number',
    'select',
    'link',
    'media',
    'inherited',
    'boolean',
    'percentage',
    'sharepoint_connector',
    'prototype',
    'role',
    'workflowStatus',
    'street',
];

// Not `media`: its value is picked from a grid, the link's, which has no per-language rendering —
// offering "Different per Language" would store one value per language and show none of them.
const MULTI_LANG_FIELDS = ['text', 'html', 'image', 'file', 'currency', 'select'];
const MULTI_VALUE_FIELDS = ['file', 'link', 'media', 'image', 'select', 'role'];
const TRANSLATABLE_FIELDS = ['file', 'html', 'text'];

/**
 * Field types whose value is a media id rather than text. `media` is one of them: it stores the
 * id of a MEDIA node, which for an uploaded file is the asset id as well.
 */
const MEDIA_VALUE_FIELDS = ['file', 'image', 'media'];

export function isMediaValueField(contentType: string): boolean {
    return MEDIA_VALUE_FIELDS.includes(contentType);
}

export function isFormField(contentType: string): boolean {
    return FORM_FIELDS.includes(contentType);
}

export function isMultiLangField(contentType: string): boolean {
    return MULTI_LANG_FIELDS.includes(contentType);
}

export function isTranslatableField(contentType: string): boolean {
    return TRANSLATABLE_FIELDS.includes(contentType);
}

export function isMultiValueField(contentType: string): boolean {
    return MULTI_VALUE_FIELDS.includes(contentType);
}

export function isTranslatableContent(contentType: ContentType | undefined) {
    if (!contentType) return false;
    return (
        contentType.multiLanguage &&
        isMultiLangField(contentType.type) &&
        isTranslatableField(contentType.type)
    );
}

export const getTablePaginationRowsLabel = (size: number, pageIndex = 0, total = 0) => {
    const start = size * pageIndex + 1;
    const end = Math.min(total, size * (pageIndex + 1));
    return `${start}-${end} of ${total}`;
};
